export const toShortISOString = (date: Date) => {
  let month = "";
  let dt = "";

  if (date.getDate() < 10) {
    dt = "0" + date.getDate().toString();
  } else {
    dt = date.getDate().toString();
  }

  if (date.getMonth() + 1 < 10) {
    month = "0" + (date.getMonth() + 1).toString();
  } else {
    month = (date.getMonth() + 1).toString();
  }

  return `${date.getFullYear()}-${month}-${dt}`;
};

export const startOfMonth = (date: Date) => {
  const resultDate = new Date(date);
  resultDate.setDate(1);
  resultDate.setHours(0, 0, 0, 0);

  return resultDate;
};

export const startOfYear = (date: Date) => {
  const resultDate = new Date(date);
  resultDate.setDate(1);
  resultDate.setMonth(0);
  resultDate.setHours(0, 0, 0, 0);

  return resultDate;
};

export const dateToShortString = (date: Date) => {
  return `${date.getFullYear()}${date.getMonth() + 1}${date.getDate()}`;
};

export const dateFromYYYYMMDD = (stringDate: string) => {
  const dateArray = stringDate.split("-").map((period) => parseInt(period));
  return new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
};

export const dateToYYYYMMDD = (date: Date) => {
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
};

export const isDateInRange = (
  date: Date,
  startDate: Date | undefined,
  endDate: Date | undefined
) => {
  const dateTime = date.getTime();
  const isOlder = !startDate || dateTime >= startDate.getTime();
  const isYounger = !endDate || dateTime <= endDate.getTime();

  return isOlder && isYounger;
};
